import lightFormat from 'date-fns/lightFormat';

/**
 * Возвращает дату в формате 01.02.2003
 *
 * @param date - дата в формате ISO (2023-12-14T12:09:41.6649366+03:00)
 */
export const formatLongDate = (dateRaw: string | Date): string => {
  const date = new Date(dateRaw);

  return lightFormat(date, 'dd.MM.yyyy');
};
